import type Feature from 'ol/Feature'
import type Geometry from 'ol/geom/Geometry'
import type { OptionalSelectionModifiers } from '@/atoms'

import { setCrudSelection } from '@/atoms'

import { getConnectedList } from '../../../../atoms/selection/read/getConnectedList'
import { getMapSelectionContext } from '../../../../atoms/selection/read/getMapSelectionContext'

export function clickTrafficArea(
  feature: Feature<Geometry>,
  modifiers: OptionalSelectionModifiers,
) {
  const connectedList = getConnectedList()
  const mapSelectionContext = getMapSelectionContext()

  const areaId = feature.getId()?.toString()

  if (!areaId) return

  const selection = [areaId]

  // select
  if (mapSelectionContext.type === 'crud') {
    if (mapSelectionContext.category === 'trafficArea') {
      setCrudSelection('trafficArea', selection, { modifiers })

      // try to scroll to
      if (
        connectedList.status === 'connected' &&
        connectedList.category === 'trafficAreas' &&
        !connectedList.disabled
      ) {
        connectedList.scrollTo(areaId)
      }
    }
  }
}
